export default __webpack_public_path__ + "static/media/screen1.8a882dcb.jpg";